import { Module } from 'vuex'
import { RootState } from '../types'
import { RegistrationState } from './types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'

export const registration: Module<RegistrationState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions
}
